export default {
    bookings: state => state.bookings,
    activeBooking: state => state.activeBooking,
    manageBookingDialog: state => state.manageBookingDialog,
    deleteBookingDialog: state => state.deleteBookingDialog
}
